import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.number.constructor.js";
import toArray from 'utils/toArray';
var BASE_TEAM_KEY = 'team';
var teamKeys = {
  allTeams: function allTeams() {
    return [BASE_TEAM_KEY];
  },
  teams: function teams(query) {
    var _query$teamIds, _query$contentIds, _toArray;
    return [BASE_TEAM_KEY, 'teams-list', (_query$teamIds = query.teamIds) === null || _query$teamIds === void 0 ? void 0 : _query$teamIds.sort().toString(), query.search, query.teamTypeId, (_query$contentIds = query.contentIds) === null || _query$contentIds === void 0 ? void 0 : _query$contentIds.sort().toString(), (_toArray = toArray(query.userIds)) === null || _toArray === void 0 ? void 0 : _toArray.sort().toString(), query.includeCalculatedTeams, query.filter];
  },
  teamTypes: [BASE_TEAM_KEY, 'team-types'],
  teamManagers: function teamManagers(ids) {
    return [BASE_TEAM_KEY, 'team-managers', ids];
  },
  teamLogs: function teamLogs(_ref) {
    var limit = _ref.limit,
      _ref$search = _ref.search,
      search = _ref$search === void 0 ? null : _ref$search;
    return [BASE_TEAM_KEY, 'logs', Number(limit), search];
  }
};
export default teamKeys;